import { Icon } from '@flatfile/design-system'
import styled from 'styled-components'

export const LinkIcon = styled(Icon)`
  margin-bottom: -3px;
`
